import { LoginResponse, User } from "../types/auth";
import { buildAppPath } from "../config/appBasePath";
import { API_URL } from "./apiConfig";

const TOKEN_KEY = "client_access_token";
const USER_KEY = "client_user_data";

export const clientAuthService = {
    getAccessToken: () => localStorage.getItem(TOKEN_KEY),

    redirectToLogin: () => {
        window.location.assign(buildAppPath("/login"));
    },

    getUserData: (): User | null => {
        const data = localStorage.getItem(USER_KEY);
        return data ? JSON.parse(data) : null;
    },

    setSession: (response: LoginResponse) => {
        localStorage.setItem(TOKEN_KEY, response.tokenValue);
        localStorage.setItem(USER_KEY, JSON.stringify(response.user));
    },

    clearSession: () => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
    },

    login: async (credentials: { username: string; password: string }): Promise<LoginResponse> => {
        const res = await fetch(`${API_URL}Login/Login`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                username: credentials.username,
                password: credentials.password,
                module: "2",
            }),
        });

        if (res.status === 404) {
            throw new Error("Invalid username or password.");
        }

        if (!res.ok) {
            throw new Error("Login failed. Please try again.");
        }

        const data: LoginResponse = await res.json();
        clientAuthService.setSession(data);
        return data;
    },

    logout: () => {
        clientAuthService.clearSession();
        clientAuthService.redirectToLogin();
    },
};
